class HeightOberserver extends HTMLElement {
  connectedCallback() {
    console.log('height observer connected')

    requestAnimationFrame(this.updateHeight.bind(this))
    setTimeout(this.updateHeight.bind(this), 1000)
    this.setupMutationObserver()
    this.setupResizeObserver()
  }

  updateHeight() {
    const customPropertyName = this.getAttribute('custom-property-name')

    if (!customPropertyName) {
      console.warn('Missing attribute custom-property-name, aborting height update')
      return
    }

    const height = this.getBoundingClientRect().height

    document.documentElement.style.setProperty(`--${customPropertyName}`, `${height}px`)
  }

  setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          this.updateHeight()
        }
      })
    })

    observer.observe(this, { childList: true })
  }

  setupResizeObserver() {
    try {
      const resizeObserver = new ResizeObserver(() => {
        this.updateHeight()
      })

      resizeObserver.observe(this)
    } catch (error) {
      console.warn('Next error occurred while setting up resize observer, check browser support')
      console.error(error)
      return
    }
  }
}

if (!customElements.get('height-observer')) {
  customElements.define('height-observer', HeightOberserver)
}
